function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".eventLoga{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2502.272 -1645.412)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2511.846 1650.46)"
}, /*#__PURE__*/React.createElement("path", {
  className: "eventLoga",
  d: "M2543.737,1672.3a.7.7,0,0,1-.7-.7v-3.993a.7.7,0,0,1,1.41,0v3.993A.7.7,0,0,1,2543.737,1672.3Z",
  transform: "translate(-2543.032 -1666.902)"
}), /*#__PURE__*/React.createElement("path", {
  className: "eventLoga",
  d: "M2546.338,1685.311h-2.6a.7.7,0,1,1,0-1.409h2.6a.7.7,0,1,1,0,1.409Z",
  transform: "translate(-2543.032 -1679.909)"
})), /*#__PURE__*/React.createElement("path", {
  className: "eventLoga",
  d: "M2519.942,1663.067a.7.7,0,0,1,0-1.409,7.418,7.418,0,1,0-7.418-7.418.7.7,0,0,1-1.409,0,8.827,8.827,0,1,1,8.827,8.827Z",
  transform: "translate(-6.766)"
}), /*#__PURE__*/React.createElement("path", {
  className: "eventLoga",
  d: "M2512.391,1665.711a.705.705,0,0,1-.655-.443,8.822,8.822,0,0,1,1.956-9.522.7.7,0,0,1,1,1,7.415,7.415,0,0,0-1.643,8,.7.7,0,0,1-.654.966Z",
  transform: "translate(-6.758 -7.749)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2502.272 1654.244)"
}, /*#__PURE__*/React.createElement("path", {
  className: "eventLoga",
  d: "M2514.294,1687.079a.7.7,0,0,1-.578-1.107l1.848-2.658a.7.7,0,1,1,1.157.8l-1.848,2.659A.7.7,0,0,1,2514.294,1687.079Z",
  transform: "translate(-2510.931 -1683.011)"
}), /*#__PURE__*/React.createElement("path", {
  className: "eventLoga",
  d: "M2505.634,1689.719a.7.7,0,0,1-.4-.126l-2.659-1.848a.7.7,0,0,1,.8-1.157l2.658,1.848a.7.7,0,0,1-.4,1.283Z",
  transform: "translate(-2502.272 -1685.651)"
})));

var SvgEventLog = function SvgEventLog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.732,
    height: 17.655,
    viewBox: "0 0 19.732 17.655",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEventLog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eventLog.93362e00.svg";
export { ForwardRef as ReactComponent };